import React from 'react';
import LocationSearch from '../components/LocationSearch';

const MapPage = () => {
  return (
    <div>
      <h2 style={{ textAlign: 'center', margin: '1rem 0' }}>Map Page</h2>
      <LocationSearch />
    </div>
  );
};

export default MapPage;
